module.exports = __webpack_public_path__ + "static/img/channel_share.20e388b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/channel_share.jpg
// module id = NlhK
// module chunks = 1